module.exports = __webpack_public_path__ + "img/orange_034.aa9ccd6b.png";